import { action } from 'typesafe-actions';

import * as Types from 'types';

import { MediaActionTypes } from './types';
import { requestPreviewMediaById } from './api';

export const receivePreview = (media: Types.Media) =>
  action(MediaActionTypes.RECEIVE_PREVIEW, media);

export const Actions = {
  receivePreview,
};

export const fetchArtworkPreviewById = (
  id: number,
): Types.DefaultThunkAction<Promise<Types.Media>> => async (dispatch) => {
  const response = await requestPreviewMediaById(id);
  dispatch(receivePreview(response));
  return response;
};
